// import { SurvivorsConversationStore } from './../../modules/datastores/useGetSurvivorsConversation';
import NotAvailable from '../NotAvailable';
import { Suspense } from 'react';
// const HelproomStatus = lazy(() => import('helprooms/HelproomStatus'));
import type { IVisitorHelproom } from './../../modules/algebra/waiting-room';

/**
 * child function
 */
interface FederatedHelproomProps {
  unique_identity: string;
  helproom: IVisitorHelproom | undefined;
  captcha_enabled: string | undefined;
  captcha_token: string | undefined;
}

export const FederatedHelproomStatus: React.FC<FederatedHelproomProps> = (/*{ unique_identity, helproom, captcha_enabled, captcha_token }*/) => {
  return (
    <Suspense fallback={<NotAvailable />}>
      {/* <HelproomStatus
          helproom={helproom}
          opted_in_Callback={SurvivorsConversationStore.setHelproomOpted}
          position_available_callback={SurvivorsConversationStore.helproomPositionAvailable}
          unique_identity={unique_identity}
          captcha_enabled={captcha_enabled}
          captcha_token={captcha_token}
        /> */}
    </Suspense>
  );
};